export const pseudo = (display = 'block', position = 'absolute', content = ''): string => `
  content: '${content}';
  display: ${display};
  position: ${position};
`;
